import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  card: {
    boxShadow: "none",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: "16px",
  },

  cardContent: {
    alignItems: "center",
    display: "flex",
    flexGrow: 1,
    justifyContent: "center",
    padding: "0 !important",
  },

  cardHeader: {
    padding: 0,
    paddingBottom: "16px",
    "& > .MuiCardHeader-content > .MuiCardHeader-title": {
      fontFamily: "Manrope",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 700,
      letterSpacing: "0.15px",
      lineHeight: "24px", //* 150% */
    },
  },

  fetchLoading: {
    alignItems: "center",
    display: "flex",
    height: "100%",
    justifyContent: "center",
  },

  noDataLabel: {
    height: "100%",
  },

  responsiveGraphContainer: {
    height: "calc(100% - 2px)",
    position: "relative",
    width: "100%",
  },
}));

export default useStyles;
